
import { Options, Vue } from 'vue-class-component';
import { LingerieSquareMeterConfigurationClient } from '@/services/Services';
import UploadLingerieExcelModal from '../modals/uploadLingerieExcelModal.vue';
import * as OM from '@/Model';

@Options({
    components: {}
})
export default class lingerieConfig extends Vue {

    configurations: OM.LingerieSquareMeterCombinationsConfig[] = [];

    created() {
        this.init();
    }

    init() {
        LingerieSquareMeterConfigurationClient.getConfigurationList()
        .then(x => {
            this.configurations = x;
        })
    }

    uploadExcelModal() {
        this.$opModal.show(UploadLingerieExcelModal, {
            callback: () => {
                this.$opModal.closeLast();
                this.init();
            }
        })
    }

}
